import React, { useState } from 'react';
import GlobalDialog from '../../../../../components/mui/Dialogue/GlobalDialog';
import { Box, Button } from '@mui/material';
import { Icon } from '@iconify/react/dist/iconify.js';
import FormDataPrefill from './FormDataPrefill';

const NonCartEdit = ({ rowData}) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <GlobalDialog
        title="Non Cart Edit"
        open={open}
        setOpen={setOpen}
        fullWidth
        loading={true}
        closeButton={true}
        fullScreen
        popupButton={
          <Button
            size="small"
            startIcon={<Icon icon={'mdi:edit'} />}
            variant="contained"
            disabled={rowData?.exists_in_cart === 1}
            color="secondary"
            onClick={() => setOpen(true)}
          >
            Edit
          </Button>
        }
        content={<>
        <Box>
            {open && (
            <FormDataPrefill rowData={rowData} setOpen={setOpen}/>
            )}
        </Box>
        </>}
      />
    </>
  );
};

export default NonCartEdit;
